import { Card, CardBody, Col } from "reactstrap";
import CommonFileUpload from "src/CommonElements/CommonFileUpload";
import CommonCardHeader from "../../../../CommonElements/CommonCardHeader/CommonCardHeader";
import { fileUploadData } from "../../../../Data/BonusUi/Dropzone/Dropzone";
import { SingleFileUploads } from "../../../../utils/Constant";

const SingleFileupload = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={SingleFileUploads} span={fileUploadData} />
        <CardBody>
          <CommonFileUpload />
        </CardBody>
      </Card>
    </Col>
  );
};

export default SingleFileupload;
